function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// Import VanillaTilt and gsap libraries
var $b5f6d4efc654cf78$exports = {};
"use strict";
var $b5f6d4efc654cf78$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
/**
 * Created by Sergiu Șandor (micku7zu) on 1/27/2017.
 * Original idea: https://github.com/gijsroge/tilt.js
 * MIT License.
 * Version 1.8.0
 */ var $b5f6d4efc654cf78$var$VanillaTilt = function() {
    function VanillaTilt(element) {
        var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $b5f6d4efc654cf78$var$classCallCheck(this, VanillaTilt);
        if (!(element instanceof Node)) throw "Can't initialize VanillaTilt because " + element + " is not a Node.";
        this.width = null;
        this.height = null;
        this.clientWidth = null;
        this.clientHeight = null;
        this.left = null;
        this.top = null;
        // for Gyroscope sampling
        this.gammazero = null;
        this.betazero = null;
        this.lastgammazero = null;
        this.lastbetazero = null;
        this.transitionTimeout = null;
        this.updateCall = null;
        this.event = null;
        this.updateBind = this.update.bind(this);
        this.resetBind = this.reset.bind(this);
        this.element = element;
        this.settings = this.extendSettings(settings);
        this.reverse = this.settings.reverse ? -1 : 1;
        this.resetToStart = VanillaTilt.isSettingTrue(this.settings["reset-to-start"]);
        this.glare = VanillaTilt.isSettingTrue(this.settings.glare);
        this.glarePrerender = VanillaTilt.isSettingTrue(this.settings["glare-prerender"]);
        this.fullPageListening = VanillaTilt.isSettingTrue(this.settings["full-page-listening"]);
        this.gyroscope = VanillaTilt.isSettingTrue(this.settings.gyroscope);
        this.gyroscopeSamples = this.settings.gyroscopeSamples;
        this.elementListener = this.getElementListener();
        if (this.glare) this.prepareGlare();
        if (this.fullPageListening) this.updateClientSize();
        this.addEventListeners();
        this.reset();
        if (this.resetToStart === false) {
            this.settings.startX = 0;
            this.settings.startY = 0;
        }
    }
    VanillaTilt.isSettingTrue = function isSettingTrue(setting) {
        return setting === "" || setting === true || setting === 1;
    };
    /**
   * Method returns element what will be listen mouse events
   * @return {Node}
   */ VanillaTilt.prototype.getElementListener = function getElementListener() {
        if (this.fullPageListening) return window.document;
        if (typeof this.settings["mouse-event-element"] === "string") {
            var mouseEventElement = document.querySelector(this.settings["mouse-event-element"]);
            if (mouseEventElement) return mouseEventElement;
        }
        if (this.settings["mouse-event-element"] instanceof Node) return this.settings["mouse-event-element"];
        return this.element;
    };
    /**
   * Method set listen methods for this.elementListener
   * @return {Node}
   */ VanillaTilt.prototype.addEventListeners = function addEventListeners() {
        this.onMouseEnterBind = this.onMouseEnter.bind(this);
        this.onMouseMoveBind = this.onMouseMove.bind(this);
        this.onMouseLeaveBind = this.onMouseLeave.bind(this);
        this.onWindowResizeBind = this.onWindowResize.bind(this);
        this.onDeviceOrientationBind = this.onDeviceOrientation.bind(this);
        this.elementListener.addEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.addEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.addEventListener("mousemove", this.onMouseMoveBind);
        if (this.glare || this.fullPageListening) window.addEventListener("resize", this.onWindowResizeBind);
        if (this.gyroscope) window.addEventListener("deviceorientation", this.onDeviceOrientationBind);
    };
    /**
   * Method remove event listeners from current this.elementListener
   */ VanillaTilt.prototype.removeEventListeners = function removeEventListeners() {
        this.elementListener.removeEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.removeEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.removeEventListener("mousemove", this.onMouseMoveBind);
        if (this.gyroscope) window.removeEventListener("deviceorientation", this.onDeviceOrientationBind);
        if (this.glare || this.fullPageListening) window.removeEventListener("resize", this.onWindowResizeBind);
    };
    VanillaTilt.prototype.destroy = function destroy() {
        clearTimeout(this.transitionTimeout);
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.reset();
        this.removeEventListeners();
        this.element.vanillaTilt = null;
        delete this.element.vanillaTilt;
        this.element = null;
    };
    VanillaTilt.prototype.onDeviceOrientation = function onDeviceOrientation(event) {
        if (event.gamma === null || event.beta === null) return;
        this.updateElementPosition();
        if (this.gyroscopeSamples > 0) {
            this.lastgammazero = this.gammazero;
            this.lastbetazero = this.betazero;
            if (this.gammazero === null) {
                this.gammazero = event.gamma;
                this.betazero = event.beta;
            } else {
                this.gammazero = (event.gamma + this.lastgammazero) / 2;
                this.betazero = (event.beta + this.lastbetazero) / 2;
            }
            this.gyroscopeSamples -= 1;
        }
        var totalAngleX = this.settings.gyroscopeMaxAngleX - this.settings.gyroscopeMinAngleX;
        var totalAngleY = this.settings.gyroscopeMaxAngleY - this.settings.gyroscopeMinAngleY;
        var degreesPerPixelX = totalAngleX / this.width;
        var degreesPerPixelY = totalAngleY / this.height;
        var angleX = event.gamma - (this.settings.gyroscopeMinAngleX + this.gammazero);
        var angleY = event.beta - (this.settings.gyroscopeMinAngleY + this.betazero);
        var posX = angleX / degreesPerPixelX;
        var posY = angleY / degreesPerPixelY;
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = {
            clientX: posX + this.left,
            clientY: posY + this.top
        };
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseEnter = function onMouseEnter() {
        this.updateElementPosition();
        this.element.style.willChange = "transform";
        this.setTransition();
    };
    VanillaTilt.prototype.onMouseMove = function onMouseMove(event) {
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = event;
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseLeave = function onMouseLeave() {
        this.setTransition();
        if (this.settings.reset) requestAnimationFrame(this.resetBind);
    };
    VanillaTilt.prototype.reset = function reset() {
        this.onMouseEnter();
        if (this.fullPageListening) this.event = {
            clientX: (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.clientWidth,
            clientY: (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.clientHeight
        };
        else this.event = {
            clientX: this.left + (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.width,
            clientY: this.top + (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.height
        };
        var backupScale = this.settings.scale;
        this.settings.scale = 1;
        this.update();
        this.settings.scale = backupScale;
        this.resetGlare();
    };
    VanillaTilt.prototype.resetGlare = function resetGlare() {
        if (this.glare) {
            this.glareElement.style.transform = "rotate(180deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "0";
        }
    };
    VanillaTilt.prototype.getValues = function getValues() {
        var x = void 0, y = void 0;
        if (this.fullPageListening) {
            x = this.event.clientX / this.clientWidth;
            y = this.event.clientY / this.clientHeight;
        } else {
            x = (this.event.clientX - this.left) / this.width;
            y = (this.event.clientY - this.top) / this.height;
        }
        x = Math.min(Math.max(x, 0), 1);
        y = Math.min(Math.max(y, 0), 1);
        var tiltX = (this.reverse * (this.settings.max - x * this.settings.max * 2)).toFixed(2);
        var tiltY = (this.reverse * (y * this.settings.max * 2 - this.settings.max)).toFixed(2);
        var angle = Math.atan2(this.event.clientX - (this.left + this.width / 2), -(this.event.clientY - (this.top + this.height / 2))) * (180 / Math.PI);
        return {
            tiltX: tiltX,
            tiltY: tiltY,
            percentageX: x * 100,
            percentageY: y * 100,
            angle: angle
        };
    };
    VanillaTilt.prototype.updateElementPosition = function updateElementPosition() {
        var rect = this.element.getBoundingClientRect();
        this.width = this.element.offsetWidth;
        this.height = this.element.offsetHeight;
        this.left = rect.left;
        this.top = rect.top;
    };
    VanillaTilt.prototype.update = function update() {
        var values = this.getValues();
        this.element.style.transform = "perspective(" + this.settings.perspective + "px) " + "rotateX(" + (this.settings.axis === "x" ? 0 : values.tiltY) + "deg) " + "rotateY(" + (this.settings.axis === "y" ? 0 : values.tiltX) + "deg) " + "scale3d(" + this.settings.scale + ", " + this.settings.scale + ", " + this.settings.scale + ")";
        if (this.glare) {
            this.glareElement.style.transform = "rotate(" + values.angle + "deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "" + values.percentageY * this.settings["max-glare"] / 100;
        }
        this.element.dispatchEvent(new CustomEvent("tiltChange", {
            "detail": values
        }));
        this.updateCall = null;
    };
    /**
   * Appends the glare element (if glarePrerender equals false)
   * and sets the default style
   */ VanillaTilt.prototype.prepareGlare = function prepareGlare() {
        // If option pre-render is enabled we assume all html/css is present for an optimal glare effect.
        if (!this.glarePrerender) {
            // Create glare element
            var jsTiltGlare = document.createElement("div");
            jsTiltGlare.classList.add("js-tilt-glare");
            var jsTiltGlareInner = document.createElement("div");
            jsTiltGlareInner.classList.add("js-tilt-glare-inner");
            jsTiltGlare.appendChild(jsTiltGlareInner);
            this.element.appendChild(jsTiltGlare);
        }
        this.glareElementWrapper = this.element.querySelector(".js-tilt-glare");
        this.glareElement = this.element.querySelector(".js-tilt-glare-inner");
        if (this.glarePrerender) return;
        Object.assign(this.glareElementWrapper.style, {
            "position": "absolute",
            "top": "0",
            "left": "0",
            "width": "100%",
            "height": "100%",
            "overflow": "hidden",
            "pointer-events": "none",
            "border-radius": "inherit"
        });
        Object.assign(this.glareElement.style, {
            "position": "absolute",
            "top": "50%",
            "left": "50%",
            "pointer-events": "none",
            "background-image": "linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",
            "transform": "rotate(180deg) translate(-50%, -50%)",
            "transform-origin": "0% 0%",
            "opacity": "0"
        });
        this.updateGlareSize();
    };
    VanillaTilt.prototype.updateGlareSize = function updateGlareSize() {
        if (this.glare) {
            var glareSize = (this.element.offsetWidth > this.element.offsetHeight ? this.element.offsetWidth : this.element.offsetHeight) * 2;
            Object.assign(this.glareElement.style, {
                "width": glareSize + "px",
                "height": glareSize + "px"
            });
        }
    };
    VanillaTilt.prototype.updateClientSize = function updateClientSize() {
        this.clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this.clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    };
    VanillaTilt.prototype.onWindowResize = function onWindowResize() {
        this.updateGlareSize();
        this.updateClientSize();
    };
    VanillaTilt.prototype.setTransition = function setTransition() {
        var _this = this;
        clearTimeout(this.transitionTimeout);
        this.element.style.transition = this.settings.speed + "ms " + this.settings.easing;
        if (this.glare) this.glareElement.style.transition = "opacity " + this.settings.speed + "ms " + this.settings.easing;
        this.transitionTimeout = setTimeout(function() {
            _this.element.style.transition = "";
            if (_this.glare) _this.glareElement.style.transition = "";
        }, this.settings.speed);
    };
    /**
   * Method return patched settings of instance
   * @param {boolean} settings.reverse - reverse the tilt direction
   * @param {number} settings.max - max tilt rotation (degrees)
   * @param {startX} settings.startX - the starting tilt on the X axis, in degrees. Default: 0
   * @param {startY} settings.startY - the starting tilt on the Y axis, in degrees. Default: 0
   * @param {number} settings.perspective - Transform perspective, the lower the more extreme the tilt gets
   * @param {string} settings.easing - Easing on enter/exit
   * @param {number} settings.scale - 2 = 200%, 1.5 = 150%, etc..
   * @param {number} settings.speed - Speed of the enter/exit transition
   * @param {boolean} settings.transition - Set a transition on enter/exit
   * @param {string|null} settings.axis - What axis should be enabled. Can be "x" or "y"
   * @param {boolean} settings.glare - if it should have a "glare" effect
   * @param {number} settings.max-glare - the maximum "glare" opacity (1 = 100%, 0.5 = 50%)
   * @param {boolean} settings.glare-prerender - false = VanillaTilt creates the glare elements for you, otherwise
   * @param {boolean} settings.full-page-listening - If true, parallax effect will listen to mouse move events on the whole document, not only the selected element
   * @param {string|object} settings.mouse-event-element - String selector or link to HTML-element what will be listen mouse events
   * @param {boolean} settings.reset - false = If the tilt effect has to be reset on exit
   * @param {boolean} settings.reset-to-start - true = On reset event (mouse leave) will return to initial start angle (if startX or startY is set)
   * @param {gyroscope} settings.gyroscope - Enable tilting by deviceorientation events
   * @param {gyroscopeSensitivity} settings.gyroscopeSensitivity - Between 0 and 1 - The angle at which max tilt position is reached. 1 = 90deg, 0.5 = 45deg, etc..
   * @param {gyroscopeSamples} settings.gyroscopeSamples - How many gyroscope moves to decide the starting position.
   */ VanillaTilt.prototype.extendSettings = function extendSettings(settings) {
        var defaultSettings = {
            reverse: false,
            max: 15,
            startX: 0,
            startY: 0,
            perspective: 1000,
            easing: "cubic-bezier(.03,.98,.52,.99)",
            scale: 1,
            speed: 300,
            transition: true,
            axis: null,
            glare: false,
            "max-glare": 1,
            "glare-prerender": false,
            "full-page-listening": false,
            "mouse-event-element": null,
            reset: true,
            "reset-to-start": true,
            gyroscope: true,
            gyroscopeMinAngleX: -45,
            gyroscopeMaxAngleX: 45,
            gyroscopeMinAngleY: -45,
            gyroscopeMaxAngleY: 45,
            gyroscopeSamples: 10
        };
        var newSettings = {};
        for(var property in defaultSettings){
            if (property in settings) newSettings[property] = settings[property];
            else if (this.element.hasAttribute("data-tilt-" + property)) {
                var attribute = this.element.getAttribute("data-tilt-" + property);
                try {
                    newSettings[property] = JSON.parse(attribute);
                } catch (e) {
                    newSettings[property] = attribute;
                }
            } else newSettings[property] = defaultSettings[property];
        }
        return newSettings;
    };
    VanillaTilt.init = function init(elements, settings) {
        if (elements instanceof Node) elements = [
            elements
        ];
        if (elements instanceof NodeList) elements = [].slice.call(elements);
        if (!(elements instanceof Array)) return;
        elements.forEach(function(element) {
            if (!("vanillaTilt" in element)) element.vanillaTilt = new VanillaTilt(element, settings);
        });
    };
    return VanillaTilt;
}();
if (typeof document !== "undefined") {
    /* expose the class to window */ window.VanillaTilt = $b5f6d4efc654cf78$var$VanillaTilt;
    /**
   * Auto load
   */ $b5f6d4efc654cf78$var$VanillaTilt.init(document.querySelectorAll("[data-tilt]"));
}
$b5f6d4efc654cf78$exports = $b5f6d4efc654cf78$var$VanillaTilt;


const $065bd7ae4664bf90$var$template = document.createElement("template");
$065bd7ae4664bf90$var$template.innerHTML = `
<style>
.cover {
	background-color: #333;
	width: 80px;
	height: 55px;
	position: absolute;
	top: 0;
	overflow: hidden;
}

.flipper {
	border-top: 1px solid #333;
	background-color: #333;
	width: 90px;
	height: 55px;
	position: absolute;
	top: 50%;
	transform: rotateX(-180deg);
	transform-origin: top;
	overflow: hidden;
}

.flipper span.tickerTxt {
	top: -112%;
	transform: scaleY(-1);
	position: absolute;
}

.flipper span.tickerTxt.inverse {
	transform: scaleY(1);
	top: -112%;
}

.credit-card {
	border-radius: 16px;
	background: linear-gradient(45deg, #1be7ff, #833ab4);
	transform-style: preserve-3d;
	transition: 0.2s;
	background-image: url(__CARD1_URL__);
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;
}

.card-image {
	width: 100%;
	height: 100%;
	border-radius: 8px;
	position: absolute;
	top: 0;
	left: 0;
	transform: translateZ(1px);
}

.player-cutout,
.slab-cutout {
	transition: transform 500ms;
}

.player-cutout,
.player-cutout-shadow,
.slab-cutout,
.slab-cutout-shadow {
	position:absolute;
	top:0;
	left:0;
	width: 100%;
	height: 100%;
	transform: translateZ(15px);

	-webkit-mask-image: url(__CUTOUT_URL__);
	-webkit-mask-size: contain;
	-webkit-mask-image: url(__CUTOUT_URL__);
	mask-size: contain;
	mask-position: center;
	mask-repeat: no-repeat;

	background-image: url(__CARD1_URL__);
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;
}

.player-cutout-shadow {
	position: absolute;
	top: 0;
	transform: translateZ(1px);
	background: rgba(0, 0, 0, 0.9);
	filter: brightness(0.5);
}

.slab-cutout, .slab-cutout-shadow {
	position: absolute;
	width: 100%;
	height: 100%;
	transform: translateZ(15px);

	-webkit-mask-image: url(__SLAB_CUTOUT_URL__);
	-webkit-mask-size: contain;
	-webkit-mask-image: url(__SLAB_CUTOUT_URL__);
	mask-size: contain;
	mask-position: center;
	mask-repeat: no-repeat;

	background-image: url(__CARD1_URL__);
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;
}


.credit-card * {
	user-select: none;
}

.card-shadow {
	position: absolute;
	top: -0.2%;
	left: -0.2%;
	width: 100.4%;
	height: 100.4%;
	background: black;
	border-radius: 16px;
	transform: translateZ(-5px);
}

.luma-embed-container {
	border-radius: 16px;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

.luma-embed {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

.title,
.title-shadow {
	font-size: 40px;
	top: -50px;
	width: 100%;
	text-align: center;
	position: absolute;
}

.title-shadow {
	transform: translateZ(1px);
	color: white;
}

.title {
	transform: translateZ(10px);
	color: black;
}

.highlighted {
	transform: translateZ(30px);
	filter: brightness(1.2);
}

.slab-cutout {
	pointer-events: none;
}

</style>
<div class="credit-card">
	<div class="luma-embed"></div>
	<div class="title"></div>
	<div class="title-shadow"></div>
	<div class="slab-cutout-shadow"></div>
	<div class="slab-cutout"></div>
	<div class="player-cutout-shadow"></div>
	<div class="player-cutout"></div>
</div>
`;
//template.innerHTML = template.innerHTML.replace(/__CARD1_URL__/g, card1Url);
//template.innerHTML = template.innerHTML.replace(/__CUTOUT_URL__/g, cutoutUrl);
class $065bd7ae4664bf90$var$TiltCard extends HTMLElement {
    static get observedAttributes() {
        return [
            "data-cardurl",
            "data-cutouturl",
            "data-slaburl",
            "data-raw",
            "data-maxheight"
        ];
    }
    constructor(){
        super();
        this.imageNaturalWidth = 0;
        this.imageNaturalHeight = 0;
        this.attachShadow({
            mode: "open"
        });
        this.shadowRoot.appendChild($065bd7ae4664bf90$var$template.content.cloneNode(true));
        this.creditCard = this.shadowRoot.querySelector(".credit-card");
        this.playerCutout = this.shadowRoot.querySelector(".player-cutout");
        this.playerCutoutShadow = this.shadowRoot.querySelector(".player-cutout-shadow");
        this.slabCutout = this.shadowRoot.querySelector(".slab-cutout");
        this.slabCutoutShadow = this.shadowRoot.querySelector(".slab-cutout-shadow");
    }
    connectedCallback() {
        const creditCard = this.shadowRoot.querySelector(".credit-card");
        const iframe = this.shadowRoot.querySelector(".luma-embed");
        const title = this.shadowRoot.querySelector(".title");
        const titleShadow = this.shadowRoot.querySelector(".title-shadow");
        if (!creditCard) throw new Error("No credit card element found");
        (0, (/*@__PURE__*/$parcel$interopDefault($b5f6d4efc654cf78$exports))).init(creditCard, {
            max: 25,
            gyroscope: true,
            perspective: 1400,
            easing: "cubic-bezier(.03,.98,.52,.99)",
            speed: 1200,
            glare: false,
            maxGlare: 0.05,
            scale: 1.07
        });
        let transforms = [
            [
                0.3541570007801056,
                0,
                -0.9351860284805298,
                0,
                0.027690572664141655,
                0.999561607837677,
                0.01048648077994585,
                0,
                0.9347759485244751,
                -0.029609695076942444,
                0.3540017008781433,
                0,
                2.287477970123291,
                1.1451492309570312,
                1.2842024564743042,
                1
            ],
            [
                0.6412413716316223,
                0,
                -0.7673392295837402,
                0,
                -0.291083425283432,
                0.9252568483352661,
                -0.2432492971420288,
                0,
                0.7099858522415161,
                0.3793412446975708,
                0.5933129787445068,
                0,
                1.2500770092010498,
                0.6959248185157776,
                1.1420931816101074,
                1
            ],
            [
                0.749516487121582,
                0,
                -0.6619857549667358,
                0,
                -0.06343931704759598,
                0.9953976273536682,
                -0.07182754576206207,
                0,
                0.6589389443397522,
                0.09583184123039246,
                0.7460668683052063,
                0,
                3.252533197402954,
                0.8985317945480347,
                3.795732021331787,
                1
            ]
        ];
        creditCard.addEventListener("tiltChange", function(event) {
            const tiltPercentageX = -event.detail.percentageX;
            const tiltPercentageY = event.detail.percentageY;
            const transform = transforms[0].map((value, index)=>{
                if (index === 12) return value + tiltPercentageX / 100;
                else if (index === 13) return value + tiltPercentageY / 100;
                else return value;
            });
        });
    }
    attributeChangedCallback(name, oldValue, newValue) {
        this.render();
    }
    updateSize() {
        let width = this.imageNaturalWidth;
        let height = this.imageNaturalHeight;
        let aspectRatio = width / height;
        if (width > 350) {
            width = 350;
            height = width / aspectRatio;
        }
        if (height > this.maxHeight) {
            height = this.maxHeight;
            width = height * aspectRatio;
        }
        this.creditCard.style.width = `${width}px`;
        this.creditCard.style.height = `${height}px`;
    //delete img element
    }
    render() {
        let _card1Url = this.getAttribute("data-cardurl") || this.defaultCardUrl;
        let _cutoutUrl = this.getAttribute("data-cutouturl") || this.defaultCutoutUrl;
        let _slabUrl = this.getAttribute("data-slaburl") || this.defaultSlabUrl;
        const _maxHeight = this.getAttribute("data-maxheight");
        if (_maxHeight) this.maxHeight = parseInt(_maxHeight);
        else this.maxHeight = 500;
        this.creditCard.style.backgroundImage = `url(${_card1Url})`;
        this.playerCutout.style.backgroundImage = `url(${_card1Url})`;
        this.playerCutoutShadow.style.backgroundImage = `url(${_card1Url})`;
        this.slabCutout.style.backgroundImage = `url(${_card1Url})`;
        this.slabCutoutShadow.style.backgroundImage = `url(${_card1Url})`;
        this.playerCutout.style.webkitMaskImage = `url(${_cutoutUrl})`;
        this.playerCutoutShadow.style.webkitMaskImage = `url(${_cutoutUrl})`;
        this.slabCutout.style.webkitMaskImage = `url(${_slabUrl})`;
        this.slabCutoutShadow.style.webkitMaskImage = `url(${_slabUrl})`;
        // Set the dimensions based on the _card1Url image.
        if (this.imageNaturalHeight === 0 || this.imageNaturalWidth === 0) {
            let img = new Image();
            img.onload = ()=>{
                this.imageNaturalHeight = img.naturalHeight;
                this.imageNaturalWidth = img.naturalWidth;
                this.updateSize();
            };
            img.src = _card1Url;
        } else this.updateSize();
    }
}
window.customElements.define("tilt-card", $065bd7ae4664bf90$var$TiltCard);


//# sourceMappingURL=index.5a53699c.js.map
